import React, { PureComponent } from "react";
import { bool, func } from "prop-types";

import BankId from "../bankid/bankid";
import DialogModal from "@/components/dialogModal";

export default class BankIdModal extends PureComponent {
  static propTypes = {
    isOpen: bool,
    onCancel: func,
    bankIdInfo: BankId.propTypes.bankIdInfo,
  };

  static defaultProps = {
    bankIdInfo: BankId.defaultProps.bankIdInfo,
  };

  render = () => {
    const { isOpen, bankIdInfo, onCancel } = this.props;

    return (
      <DialogModal
        open={isOpen}
        className="dialog-sheen"
        title={null}
        submitText={null}
        onCancel={onCancel}
        borderless
        hideCloseButton
        bodyRenderer={() => <BankId bankIdInfo={bankIdInfo} size="75px" />}
      />
    );
  };
}
